import React, { useState, useEffect } from "react";
import { Box, Button, Paper, TextField, Checkbox, TextareaAutosize,Radio } from "@mui/material";
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import DoneIcon from '@mui/icons-material/Done';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import moment from 'moment';
import api from "../../API";


const RegisterPage = (props:any) => {
  const [email, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [checkPassword, setCheckPassword] = useState<string>("")
  const [name, setName] = useState<string>("")
  const [phone, setPhone] = useState<string>("")
  const [phone_1, setPhone_1] = useState<string>("010")
  const [phone_2, setPhone_2] = useState<string>("")
  const [phone_3, setPhone_3] = useState<string>("")
  const [birth, setBirth] = useState<string>("")
  const [gender, setGender] = useState<string>("남성")
  const [address, setAddress] = useState<string>("")

  const [text, setText] = useState('');
  const [text2, setText2] = useState('');

  const [agree_1, setAgree_1] = useState(false);
  const [agree_2, setAgree_2] = useState(false);

  const [checkedEmail, setCheckedEmail] = useState("ready");
  const [checkedBirth, setCheckedBirth] = useState(true);

  const concatPhone = (num:any, idx:Number) => {
    if(idx === 1 && num.length < 4){
      console.log('첫번째' , num)
      setPhone_1(num)
      setPhone(num + "-" + phone_2+ "-" + phone_3)
      
    }else if(idx === 2 && num.length < 5){
      console.log('두번째' , num)
      setPhone_2(num)
      setPhone(phone_1 + "-" + num+ "-" + phone_3)
    }else if(idx === 3 && num.length < 5){
      console.log('세번째' , num)
      setPhone_3(num)
      setPhone(phone_1 + "-" + phone_2+ "-" + num)
      
    }

  }

  const checkAgree_1 = () => {
    setAgree_1(agree_1 => !agree_1)
  }

  const checkAgree_2 = () => {
    setAgree_2(agree_2 => !agree_2)
  }

  useEffect(() => {
    fetch('/register_txt.txt')
      .then(response => response.text())
      .then(data => setText(data))
      .catch(error => console.log(error));

    fetch('/register_txt_2.txt')
      .then(response => response.text())
      .then(data => setText2(data))
      .catch(error => console.log(error));

  }, []);

  const open = props.switchPage;
  var control = 'none';
  if(open)
      control = 'block'

  const checkEmail = async () => {
    console.log(email, password);

    var regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
    // 형식에 맞는 경우 true 리턴
    console.log('이메일 유효성 검사 :: ', regExp.test(email))
    if(!regExp.test(email)){
      setCheckedEmail("no")
    }else{
      console.log('register url' , window.location.origin.replace(':3000',':9680').replace('http','https')+"/checkEmail")
      const resp = await api.get("/checkEmail",{params : {email:email}})
        .then(() => setCheckedEmail("ok"))
        .catch(() => setCheckedEmail("no"));
    }

  }

  const RegisterUser = async () => {
    console.log(email, password);

    // setPhone(phone_1 + "-" + phone_2+ "-" + phone_3)
    
    // console.log('phone' , phone)
    // return ;

    if(checkedEmail != 'ok'){
      alert('이메일 중복 확인을 진행하세요.')
      return
    }

    if(password.length < 8){
      alert('패스워드는 최소8자리 이상이어야 합니다.')
      return
    }

    if(!(checkPassword === password)){
      alert('패스워드가 불일치 합니다.')
      return
    }

    if(name.length < 1){
      alert('이름을 입력 해주세요.')
      return
    }

    if(address.length < 1){
      alert('주소을 입력 해주세요.')
      return
    }

    if(phone.length < 1){
      alert('전화번호을 입력 해주세요.')
      return
    }

    if(phone.length < 1){
      alert('전화번호을 입력 해주세요.')
      return
    }

    if(!(agree_1 && agree_2)){
      alert('약관을 확인 해주세요.')
      return
    }
      
    let checkBirth = moment(birth, 'YYMMDD',true).isValid();
    if(!checkBirth){
      setCheckedBirth(false)
      alert('생년월일을 확인 해주세요.')
      return
    }

    try {
      const resp = await api.post("/register",
        {email,password,name,phone,birth,gender,address},
        {withCredentials: true});

        window.location.href = '/welcome';
    } catch (error: any) {
        if (error.response.status === 401){
            alert("Invalid credentails");
        }   
    }
  }

  return (
    <Box display={control}>
      <Box sx={{display: 'flex', justifyContent: "center", padding:"72px"}}>
        <Paper sx={{width:"770px", margin: "0px", padding: "16px", borderTop: "4px solid #3e36a5"}}>
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "20px", letterSpacing:"-2px"}}>가입신청</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <form>
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="email" id="reg_email" label="아이디(이메일)을 입력해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setEmail(e.target.value)} value={email} />
              <Button sx={{backgroundColor:"#878787", fontWeight: 600, height: "26px", width: "234px", marginTop: "6px"}} variant="contained" onClick={checkEmail} >이메일 중복 확인</Button>
              { checkedEmail === "ready" ? "" : 
                <React.Fragment>
                    <Box sx={{color:"red", display : checkedEmail === "no" ? "block":"none"}}><PriorityHighIcon  fontSize="small" sx={{color:"red"}} />사용할 수 없는 이메일 입니다.</Box>
                    <Box sx={{color:"blue", display : checkedEmail === "ok" ? "block":"none"}}><DoneIcon fontSize="small" sx={{color:"green"}} />사용가능한 Email 입니다.</Box>
                </React.Fragment>
              }
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="password" id="reg_password" label="비밀번호를 입력해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setPassword(e.target.value)} value={password} />
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="password" id="checkPassword" label="비밀번호를 확인해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setCheckPassword(e.target.value)} value={checkPassword} />
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="text" id="name" label="성명을 기재해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setName(e.target.value)} value={name} />
              <Box display="flex">
                <TextField sx={{backgroundColor:"#fff", marginTop:"16px", width:"50%"}} type="text" id="birth" label="생년월일(6자리 000000)" variant="outlined" fullWidth size="small" onChange={(e) => setBirth(e.target.value)} value={birth} />
                <Box display="flex" alignSelf="center" sx={{margin: "12px 0 0 24px"}}>
                  <Box>
                    남<Radio
                    checked={gender === '남성'}
                    onChange={() => setGender("남성")}
                    value="남성"
                    />
                  </Box>
                  <Box>
                    여
                    <Radio
                      checked={gender === '여성'}
                      onChange={() => setGender("여성")}
                      value="여성"
                    />
                  </Box>
                </Box>
                
                {/* <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="text" id="gender" label="주소를 입력해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setGender(e.target.value)} value={gender} /> */}
              </Box>
              {!checkedBirth ? <Box sx={{color:"red"}}><PriorityHighIcon fontSize="small" sx={{color:"red"}} />생년월일을 확인해주세요.</Box> : <></>}
              <TextField sx={{backgroundColor:"#fff", marginTop:"16px"}} type="text" id="gender" label="주소를 입력해주세요" variant="outlined" fullWidth size="small" onChange={(e) => setAddress(e.target.value)} value={address} />
              <Box display="flex" sx={{ alignItems: "baseline"}}>
                <TextField margin="dense" sx={{backgroundColor:"#fff", marginTop:"16px", width:"100px"}} type="text" id="phone_1" variant="outlined" size="small" label="전화번호" onChange={(e) => concatPhone(e.target.value, 1)} value={phone_1} />
                <Box display="flex" alignSelf="center" sx={{margin: "12px 0 0 0px"}}><HorizontalRuleIcon /></Box><TextField sx={{backgroundColor:"#fff", marginTop:"16px", width:"140px"}} type="text" id="phone_2" variant="outlined" size="small" label="전화번호(앞4자리)" onChange={(e) => concatPhone(e.target.value,2)} value={phone_2} />
                <Box display="flex" alignSelf="center" sx={{margin: "12px 0 0 0px"}}><HorizontalRuleIcon /></Box><TextField sx={{backgroundColor:"#fff", marginTop:"16px", width:"140px"}} type="text" id="phone_3" variant="outlined" size="small" label="전화번호(뒷4자리)" onChange={(e) => concatPhone(e.target.value,3)} value={phone_3} />
              </Box>
            </form>
            </Box>
        
          <Box>
            <Box display="flex" sx={{margin:"8px 0 0 16px"}}>
              <TripOriginIcon sx={{fontSize:"12px", color:"red", marginTop:"2px"}} /> <Box sx={{fontSize:"12px", fontWeight:500, marginLeft:"8px"}}>가입 신청과 입사서류 제출 후 관리자 승인 시 고유 ID를 부여 합니다.</Box>
            </Box>
          </Box>
          <Box display="flex" sx={{margin:"8px 0 0 16px"}}>
            <TripOriginIcon sx={{fontSize:"12px", color:"red", marginTop:"2px"}} /> <Box sx={{fontSize:"12px", fontWeight:500, marginLeft:"8px"}}>고유 ID가 발급되어야 접속(로그인) 가능 합니다.</Box>
          </Box>
          <Box display="flex" sx={{margin:"8px 0 0 16px"}}>
            <TripOriginIcon sx={{fontSize:"12px", color:"red", marginTop:"2px"}} /> <Box sx={{fontSize:"12px", fontWeight:500, marginLeft:"8px"}}>고유 ID는 신청하신 E-Mail로 발송됩니다. (처리기간: 신청 완료 후 2일 이내)</Box>
          </Box>

          <Box sx={{marginTop:4}}>
            <Box sx={{fontWeight:600}}>회원이용약관에 동의</Box>
            <TextareaAutosize style={{width:"99%", minWidth: "99%", maxWidth: "99%", minHeight:"120px", maxHeight: "200px"}} defaultValue={text} maxRows={8} minRows={8}></TextareaAutosize>
          </Box>
          <Box sx={{display:"flex", padding:1}}>
              <Checkbox sx={{alignSelf:"center"}} onChange={checkAgree_1} checked={agree_1}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>이용약관에 동의합니다.</Box>    
          </Box>

          <Box sx={{marginTop:2}}>
            <Box sx={{fontWeight:600}}>개인정보수집 및 이용동의</Box>
            <TextareaAutosize style={{width:"99%", minWidth: "99%", maxWidth: "99%", minHeight:"120px", maxHeight: "200px"}} defaultValue={text2} maxRows={8} minRows={8}></TextareaAutosize>
          </Box>
          <Box sx={{display:"flex", padding:1}}>
              <Checkbox sx={{alignSelf:"center"}} onChange={checkAgree_2} checked={agree_2}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>개인정보 수집 및 이용 동의합니다.</Box>    
          </Box>

          <Box sx={{display:"flex", justifyContent: "center", marginTop:6}}>
            <Box width="35%" textAlign="center">
              <Button sx={{width:"80%", height:"38px", magin:"24px", fontSize:"20px", fontWeight:700, color:"#fff", backgroundColor:"#3e36a5",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px"}} type="button" onClick={() => RegisterUser()}>신청하기</Button>
              <Button sx={{width:"80%", height:"38px", magin:"24px", fontSize:"20px", fontWeight:700, color:"#000", backgroundColor:"#eee",':hover': {bgcolor: '#4caf50', color: 'black'}, letterSpacing:"4px", marginTop:2}} type="button" onClick={() => props.setSwitchPage(false)}>취소</Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default RegisterPage;
